import { Button, ButtonGroup } from '@mui/material';
import React from 'react';

interface IButtonSwitchProps {
	labels: string[];
	onClick: (index: number) => void;
}

const ButtonSwitch: React.FC<IButtonSwitchProps> = ({ labels, onClick }) => {
	const [selected, setSelected] = React.useState(0);

	const handleClick = React.useCallback(
		(index: number) => {
			setSelected(index);
			onClick(index);
		},
		[setSelected, onClick]
	);

	return (
		<ButtonGroup size="small" aria-label="small button group">
			{labels.map((label, index) => (
				<Button
					key={label}
					variant={selected === index ? 'contained' : 'outlined'}
					onClick={() => handleClick(index)}
					data-testid={`button-switch-${label}`}
				>
					{label}
				</Button>
			))}
		</ButtonGroup>
	);
};

export default ButtonSwitch;
